// extracted by mini-css-extract-plugin
export default {"subjectTab":"subjectTab-MV5hG"};